export const monthlyExpenseFields = [
  { name: "rentOrMortgage", label: "Rent or Mortgage" },
  { name: "propertyTaxes", label: "Property Taxes" },
  { name: "homeInsurance", label: "Home Insurance" },
  { name: "utilities", label: "Utilities" },
  { name: "foodGroceries", label: "Food & Groceries" },
  { name: "eatingOut", label: "Eating Out" },
  { name: "transportation", label: "Transportation" },
  { name: "healthInsurance", label: "Health Insurance" },
  { name: "healthCareOutOfPocket", label: "Out-of-Pocket Healthcare" },
  { name: "childcare", label: "Childcare" },
  { name: "education", label: "Education" },
  { name: "clothing", label: "Clothing" },
  { name: "laundryCleaning", label: "Laundry & Cleaning" },
  { name: "entertainment", label: "Entertainment" },
  { name: "insuranceOther", label: "Other Insurance" },
  { name: "savingsInvestment", label: "Savings & Investments" },
  { name: "charitableContributions", label: "Charitable Contributions" },
  { name: "installmentPayments", label: "Installment Payments" },
];
